// JS bridge to the native AudioRoute plugin (ios/App/App/AudioRoutePlugin.swift,
// android/.../AudioRoutePlugin.java). Controls where call audio plays:
// earpiece, speaker, wired or Bluetooth headset.
//
// On the web there is no routing API, so everything resolves to "unsupported"
// and the call UI hides the audio-output control.

import { Capacitor, registerPlugin } from '@capacitor/core';

const AudioRoute = registerPlugin('AudioRoute');

const EMPTY = { devices: [], current: null };

const isSupported = () => Capacitor.isNativePlatform();

const safe = async (fn) => {
  if (!isSupported()) return EMPTY;
  try {
    return (await fn()) || EMPTY;
  } catch (err) {
    console.warn('[AudioRoute]', err);
    return EMPTY;
  }
};

/** Switch the device into call audio mode (earpiece / connected headset by default). */
export const startCallAudio = () => safe(() => AudioRoute.start());

/** Restore normal media audio after a call. */
export const stopCallAudio = () => safe(() => AudioRoute.stop());

/** Route call audio to a device id from the `devices` list. */
export const setCallAudioDevice = (id) => safe(() => AudioRoute.setDevice({ id }));

/** Current devices and active output. */
export const getCallAudioState = () => safe(() => AudioRoute.getState());

/** Subscribe to device/route changes (headset connected, etc.). Returns an unsubscribe fn. */
export const onCallAudioChange = (callback) => {
  if (!isSupported()) return () => {};
  const handle = AudioRoute.addListener('routeChange', callback);
  return () => {
    Promise.resolve(handle).then((h) => h?.remove()).catch(() => {});
  };
};
